import GlobalControlStore from '../store/GlobalControlStore'
import ThermodynamicStore from '../store/ThermodynamicStore'
import OverViewViewStore from '../store/OverViewViewStore'
import UserInfoStore from '../store/UserInfoStore'
import ChosenCanStatusStore from '../store/ChosenCanStatusStore'
import DistributeCansViewStore from '../store/DistributeCansViewStore'
import EquipmentViewStore from '../store/EquipmentViewStore'
import GroupInfoStore from '../store/GroupInfoStore'
import MapStore from '../store/MapStore'
import ManagementViewStore from '../store/ManagementViewStore'
import CansStore from '../store/CansStore'
import AnalysisStore from '../store/AnalysisStore'
import DataDetailsStore from '../store/DataDetailsStore'
import PathPlanningStore from '../store/PathPlanningStore'
import CreateGroupStore from '../store/CreateGroupStore'

import moment from 'moment'

function clearStore() {
  UserInfoStore.id = null
  UserInfoStore.role = null
  UserInfoStore.username = null
  UserInfoStore.groupId = null
  UserInfoStore.initFlag = false
  CreateGroupStore.groupInfoIntergrity = 0
  CreateGroupStore.groupNoGroup = true
  CreateGroupStore.groupBuildGroup = false
  CreateGroupStore.buildSuccess = false
  CansStore.cansNeedUpdate = false
  CansStore.cansStatusMap = new Map()
  CansStore.cansReminder = new Map()
  ChosenCanStatusStore.setCanId(null)
  ChosenCanStatusStore.canInfo = null
  ChosenCanStatusStore.supervisorPhone = null
  ChosenCanStatusStore.supervisorName = null
  ChosenCanStatusStore.previousId = null
  ChosenCanStatusStore.statistics = []
  DistributeCansViewStore.cleanerWorkAreaNeedUpdate = false
  DistributeCansViewStore.distributeInputValue = ''
  DistributeCansViewStore.unallocatInputValue = ''
  DistributeCansViewStore.hideInfoFlag = true
  DistributeCansViewStore.cleanerInfo = null
  DistributeCansViewStore.enableDistribute = false
  DistributeCansViewStore.distrubuteSearchShow = false
  DistributeCansViewStore.distrubuteIsShow = false
  DistributeCansViewStore.distributeAllCheck = false
  DistributeCansViewStore.distributeCheckNum = 0
  DistributeCansViewStore.distributeCansMap = new Map()
  DistributeCansViewStore.distributeChoseCan = null
  DistributeCansViewStore.unallocatChoseCan = null
  DistributeCansViewStore.unallocatAllCheck = false
  DistributeCansViewStore.unallocatCheckNum = 0
  DistributeCansViewStore.unallocatCansMap = new Map()
  EquipmentViewStore.equipmentInfoMap = new Map()
  EquipmentViewStore.loadingFlag = true
  EquipmentViewStore.isDelete = true
  EquipmentViewStore.maxCount = null
  EquipmentViewStore.choseDetailId = null
  EquipmentViewStore.choseState = false
  EquipmentViewStore.currentPage = 1
  EquipmentViewStore.canCurrentPage = 1
  GroupInfoStore.ownerInfo = null
  GroupInfoStore.groupName = null
  GroupInfoStore.needUpdate = false
  MapStore.currentPosition = null
  MapStore.needCenter = false
  MapStore.currentLat = null
  MapStore.currentLng = null
  ManagementViewStore.noGroupFlag = false
  ManagementViewStore.searchFlag = false
  ManagementViewStore.searchListMap = new Map()
  ManagementViewStore.searchId = null
  ManagementViewStore.searchContent = ''
  ManagementViewStore.editArea = false
  ManagementViewStore.editCleaner = false
  ManagementViewStore.registerArea = false
  ManagementViewStore.registerCleaner = false
  OverViewViewStore.currentCity = null
  OverViewViewStore.showNotice = true
  OverViewViewStore.showTips = false
  OverViewViewStore.isShowLogo = true
  OverViewViewStore.showlogout = false
  OverViewViewStore.showEmptyCans = false
  OverViewViewStore.hideInfoFlag = true
  OverViewViewStore.hideCansListFlag = true
  OverViewViewStore.showList = false
  OverViewViewStore.showAll = true
  OverViewViewStore.showRed = false
  OverViewViewStore.showYellow = false
  OverViewViewStore.showGreen = false
  OverViewViewStore.positive = false
  OverViewViewStore.reverse = true
  OverViewViewStore.showName = true
  OverViewViewStore.showSouSuo = false
  OverViewViewStore.souContent = ''
  OverViewViewStore.souList = []
  OverViewViewStore.showRoll = true
  OverViewViewStore.NoticeCanNeedUpdate = false
  OverViewViewStore.audioItem = null
  AnalysisStore.cumulativeRecovery = 0
  AnalysisStore.averageNum = 0
  AnalysisStore.addressArr = []
  AnalysisStore.choseAddress = '全部'
  AnalysisStore.choseCity = ''
  AnalysisStore.totalPage = 1
  AnalysisStore.areaPage = 1
  AnalysisStore.cleanerArr = []
  AnalysisStore.cleanerNum = 0
  AnalysisStore.cleanerWorkingNum = 0
  AnalysisStore.mapCanArr = []
  AnalysisStore.mapCarArr = []
  DataDetailsStore.addressArr = []
  DataDetailsStore.choseAddress = ['全部']
  DataDetailsStore.totalPage = 1
  DataDetailsStore.currentPage = 1
  DataDetailsStore.areaArr = []
  PathPlanningStore.formTips = false
  PathPlanningStore.clearTime = '--'
  PathPlanningStore.chooseCanInfo = '--'
  PathPlanningStore.chooseCurrent = true
  PathPlanningStore.showDialog = false
  PathPlanningStore.endIsGarage = false
  PathPlanningStore.havePoint = false
  PathPlanningStore.date = moment()
  PathPlanningStore.showList = false
  PathPlanningStore.isInputGarge = false
  PathPlanningStore.havePlanningPath = false
  PathPlanningStore.isBeforeToday = false
  clearInterval(CansStore.backgroundInterval)
}
export { clearStore }



// WEBPACK FOOTER //
// ./src/utils/clearStore.js